module.exports = __webpack_public_path__ + "img/plant.205149c9.png";